import React from 'react';
interface IStatCard {
  title: string;
  value?: string;
  icon?: JSX.Element | string | SVGAElement;
}
export const StatCard = (props: IStatCard) => {
  const { title, value, icon } = props;
  return (
    <div className='grid-cols-1 outline p-5  lg:justify-center lg:items-center lg:text-center gap-3 lg:gap-5 flex flex-col outline-primary-background outline-1 bg-white w-full rounded-xl h-auto shadow-md'>
      { value && (
        <p className='text-primary-main text-4xl lg:text-6xl font-bold'>
          { value }
        </p>
      ) }
      { icon && (
        <div className='rounded-full w-10 items-center flex justify-center h-10 outline outline-1 outline-primary-main'>
          { icon }
        </div>
      ) }

      <h3 className='text-primary-main  font-bold text-lg lg:text-xl'>
        { title }
      </h3>
    </div>
  );
};
